/**
 * 推荐商品
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/6/27      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from 'react'
import PropTypes from "prop-types";
import {Modal,Table} from 'antd';
import dayjs from "dayjs";
import {symbolMoneyUtil} from '@utils/utils';
import { loadImage } from "@utils/image-func";
import LazyLoad from 'react-lazy-load';
import "./index.less";
const Locale = require("../../../../../../utils/locale").default;
const locale = Locale.current();
const config = require("@config/config");

class RecommendList extends React.Component{
    constructor(props) {
        super(props);
    }

    /**
     * 放大图片
     */
    openImg(item){
        Modal.info({
            width: 500,
            title:false,
            icon:<i></i>,
            //这个方法无法控制按钮，故通过样式的方式屏蔽下方按钮。
            className:"modal-big-wrap",
            closable:true,
            content:<img src={loadImage(item.goodsSkuVO.skuPicUrl,500)} style={{width:'100%'}} alt=""/>
        });
    }

    getColumns(props){
        const address = config.essaone[locale];
        const {openImg,currencySymbol} = props;
        var columns = [
            {
                title: __getServerLanguage("ShangPinXinXi"),
                render(text,item) {
                    return <div className="flex-box">
                        <div className="img__wrap mr_10">
                            {
                                item.discountPercentage?
                                    <img className="discount-tag"
                                         src="https://oss.essaone.com/6b0f316c-b85f-4125-8d9f-626d7c44fae7.png" alt=""/>:null
                            }
                            {
                                item.goodsSkuVO.skuPicUrl?
                                    <LazyLoad height={140}
                                              offset={0}>
                                        <img className="img140 cursor-p" src={loadImage(item.goodsSkuVO.skuPicUrl,200)}
                                             onClick={openImg.bind(this,item)} alt=""/>
                                    </LazyLoad>
                                    :
                                    <img className="img140" src="http://oss.essa.cn/04d1ca90-811f-4d61-96d4-ada86e4bfedb.svg" alt=""/>
                            }

                        </div>

                        <div flex-box="1">
                            <div className="base-info">
                                <span className="ellipsis-name cursor-p" onClick={()=>{
                                    window.open(`${address}/${item.goodsSkuVO.goodsId}.html?skuNo=${item.goodsSkuVO.no}`);
                                }} title={item.goodsSkuVO.name||'-'}>{item.goodsSkuVO.name||'-'}</span>
                                <span>{item.goodsSkuVO.no||'-'}</span>
                                <span>{item.supplierVO.receiveAreaName||'-'}</span>
                            </div>
                            <div className="color066 font_12 mt_12">{item.goodsSkuVO.categoryPathName||'-'}</div>
                            <div className="mt_12">
                                <b className="color089">
                                    <span className="mr_4">{__getServerLanguage('DDPJiaGe')}</span>
                                    <span>
                                        {
                                        item.goodsSkuVO.isSkuCutProfitPrice == 1?
                                            <img className="cutProfitIcon mr_4"
                                                 style={{width:'17px',height:'20px',margin:'0 5px'}}
                                                 src="http://oss.essa.cn/6b0f316c-b85f-4125-8d9f-626d7c44fae7.png"
                                                 alt=""  title={__getServerLanguage('GongChangRangLiJia')}/>
                                                 :
                                            null
                                        }
                                        {symbolMoneyUtil(item.goodsSkuVO.salePrice,currencySymbol)}
                                    </span>
                                    {
                                        item.goodsSkuVO.isSkuCutProfitPrice?
                                        <s className="ml_4">
                                            {item.goodsSkuVO.orgPrice}
                                        </s>
                                        :null
                                    }
                                </b>
                                <span className="ml_16">
                                    {__getServerLanguage('HuoQi')} <span>{item.goodsSkuVO.deliverDay||'-'}</span>
                                </span>
                                <span className="ml_16">
                                    MOQ <span>{item.goodsSkuVO.purchaseMoq||'-'}</span>
                                </span>
                            </div>
                            {/*客户可享优惠（新拓产品）*/}
                            {
                                item.discountPercentage?
                                    <div className="mt_12 color_FB7321">{__getServerLanguage('KeHuKeXiangYouHuiXinTuoCh')}</div>:
                                    null
                            }
                        </div>
                    </div>
                },
            },
            {
                title: __getServerLanguage("ShangShiShiJian"),
                width: 176,
                render : (text,item) => {
                    return (
                        <span className="color089">{item.goodsSkuVO.firstToMarketTime?dayjs(item.goodsSkuVO.firstToMarketTime).format('YYYY-MM-DD HH:mm:ss'):'-'}</span>
                    )
                }
            },
            {
                title: __getServerLanguage("GongYingShang"),
                width: 139,
                render: (text,item) => {
                    return (
                        <div className="color089">
                            <p>{item.supplierVO.code||'-'}</p>
                            <p>{item.supplierVO.name||'-'}</p>
                        </div>
                    )
                },
            },
            {
                title: __getServerLanguage("TuiJianRen"),
                width: 190,
                render: (text,item) => {
                    return (
                        <div>
                            <p className="color089 font_14 mb_4">{item.createByName||'-'} {item.mobile||'-'}</p>
                            <p className="color045 font_14">{item.createTime?dayjs(item.createTime).format('YYYY-MM-DD HH:mm:ss'):'-'}</p>
                        </div>
                    )
                },
            },
            {
                title: __getServerLanguage("XuanPinZhuangTai"),
                width: 100,
                render: (text,item) => {
                    return (
                        item.isAddCart?
                            <span className="is-add-cart no-wrap">{__getServerLanguage('YiXuanPin')}</span>
                            :
                            <span className="is-no-add-cart no-wrap">{__getServerLanguage('YiTuiJian')}</span>
                    )
                },
            }
        ];
        return columns;
    }

    render(){
        let {list=[]} = this.props;
        const columns = this.getColumns;
        return (
            <div className="child-task__goods-wrap">
                <Table rowKey="id"
                       columns={columns({
                           currencySymbol:this.props.currencySymbol,
                           openImg:this.openImg.bind(this)
                       })}
                       dataSource={list}
                       pagination={false}></Table>
            </div>
        )
    }
}

RecommendList.defaultProps = {
    currencySymbol:'',
    list:[]
}

RecommendList.propTypes = {

}
export default RecommendList;
